module.exports = __webpack_public_path__ + "fonts/Oswald-SemiBold.327f53e.woff2";